<template>
  <div class="container-form">
    <Tabs :tabs="tabs" :active-tab="activeTabIndex" @tab-click="handleTabIndex" />
    <div class="my-contact-list">
      <component v-if="activeComponent" v-bind="activeComponent.attributes" :is="activeComponent.component" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { fetchSelfServiceInquiry } from '@/api/apiService';
import ContactTabAudit from '@/components/domains/self-service/contact/ContactTabAudit.vue';
import ContactTabSubmit from '@/components/domains/self-service/contact/ContactTabSubmit.vue';
import Tabs from '@/components/shared/composite/Tabs.vue';
import { IResponseSelfServiceInquiry } from '@/types/response';

const activeTabIndex = ref(0); // 현재 탭
const inquiries = ref<IResponseSelfServiceInquiry[]>([]); // 문의내역

const activeComponent = computed(() => {
  return {
    0: {
      component: ContactTabSubmit,
      attributes: {
        onInquirySubmit: submit,
      },
    },
    1: {
      component: ContactTabAudit,
      attributes: {
        inquiries: inquiries.value,
        onSearch: requestInquiries,
      },
    },
  }[activeTabIndex.value];
});

// 문의탭
const tabs = computed<string[]>(() => {
  if (inquiries.value.length > 0) {
    return ['self_service_contact_submit', 'self_service_contact_audit'];
  }
  return ['self_service_contact_submit'];
});

// 탭선택
const handleTabIndex = (tabIndex: number) => {
  activeTabIndex.value = tabIndex;
};

// 문의내역 조회
const requestInquiries = async () => {
  const { success, data } = await fetchSelfServiceInquiry({ nextoffset: null });
  if (success) {
    inquiries.value = data.datas;
  } else {
    inquiries.value = [];
  }
};

// 문의제출
const submit = async () => {
  await requestInquiries();
  handleTabIndex(1);
};

onMounted(async () => {
  await requestInquiries();
});
</script>

<style scoped lang="scss">
.container-form {
  width: 100%;
  padding: 1.5rem;
  background: #fff;
  border-radius: 12px;
  margin-top: 1rem;
  :deep(.web-tab-wrap) {
    margin-bottom: 20px;
  }
  .my-contact-list {
    overflow-y: auto;
    height: 100%;
    max-height: 320px;
  }
}
@include respond-to(mobile-landscape) {
  .container-form {
    padding: 1rem;
    .my-contact-list {
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
</style>
